module.exports = __webpack_public_path__ + "static/img/6.b22486c5.jpg";